module.exports = __webpack_public_path__ + "d79b29886e7012ab8c4316e7a81ec353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow.png
// module id = 601
// module chunks = 0